package Utils

val DOC_NAME = listOf<String>(
    "חשבונית מס",
    "חשבונית מס קבלה",
    "חשבונית מס זיכוי",
    "סיכום תעודות",
    "תעודת משלוח",
    "הכל",
    "תעודת ספק",
    "קבלה",
    "מחיר לקוח",
    "כרטסת",
    "הזמנה",
    "תעודת משלוח - החזר",
    "תעודת ביקור",
    "",
    "",
    "",
    "חשבונית ספק",
    "חשבונית ספק - קבלה",
    "חשבונית ספק זיכוי",
    "תשלום לספק",
    "חוב ספק",
    "חשבוניות פתוחות",
    "כרטסת ספק",
    "",
    "",
    "הצעת מחיר",
    "קטלוג מוצרים"
)

val DOC_NAME_SHORT = listOf<String>(
    "חש",
    "חש מס/ק",
    "זיכוי",
    "סיכום תעודות",
    "תעודה",
    "מחזור",
    "תעודת ספק",
    "קבלה",
    "מחיר לקוח",
    "כרטסת",
    "הזמנה",
    "תעודת משלוח - החזר",
    "תעודת ביקור",
    "חש מס ספק",
    "חש מס ספק - קבלה",
    "חש מס ספק זיכוי",
    "תשלום לספק",
    "חוב ספק",
    "חשבוניות פתוחות",
    "",
    "",
    "",
    "",
    "",
    "",
    "הצ מחיר",
    "קטלוג"
)

enum class DocType(val state: Int) {
    TAX_NOTE(0),
    TAX_PAY_NOTE(1),
    PAY_NOTE(7),
    SINGLE_DELIVERY_NOTE(3),
    DELIVERY_NOTES(4),
    ALL(state = 5),
    SUP_DELIVERY_NOTES(6),
    TAX_NOTE_CANCEL(2),
    CLIENT_PRICES(8),
    CLIENT_CARTESET(9),
    ORDERS(10),
    RETURNS(11),
    VISIT(12),
    PRODUCT_SUMMARY(13),
    TAX_PRI(14),
    TAX_PRI_SPLIT(15),
    SUPPLIER_INVOICE(16),
    SUPPLIER_INVOICE_RECEIPT(17),
    SUPPLIER_INVOICE_CREDIT(18),
    SUPPLIER_PAYMENT(19),
    SUPPLIER_DEBT(20),
    OPEN_INVOICES(21),
    SUP_CARTESET(22),
    CATGORY(23),
    PRODUCT_SUMMERY_CUST(24),
    PRICE_OFFER(25),
    PRODUCT_CATALOG(26),
    ;

    fun convert(s: Int): DocType {
        return when (s) {
            0 -> TAX_NOTE
            1 -> TAX_PAY_NOTE
            7 -> PAY_NOTE
            3 -> SINGLE_DELIVERY_NOTE
            4 -> DELIVERY_NOTES
            6 -> SUP_DELIVERY_NOTES
            2 -> TAX_NOTE_CANCEL
            8 -> CLIENT_PRICES
            9 -> CLIENT_CARTESET
            10 -> ORDERS
            11 -> RETURNS
            12 -> VISIT
            13 -> PRODUCT_SUMMARY
            14 -> TAX_PRI
            15 -> TAX_PRI_SPLIT
            16 -> SUPPLIER_INVOICE
            17 -> SUPPLIER_INVOICE_RECEIPT
            18 -> SUPPLIER_INVOICE_CREDIT
            19 -> SUPPLIER_PAYMENT
            20 -> SUPPLIER_DEBT
            21 -> OPEN_INVOICES
            22 -> SUP_CARTESET
            23 -> CATGORY
            24 -> PRODUCT_SUMMERY_CUST
            25 -> PRICE_OFFER
            26 -> PRODUCT_CATALOG
            else -> ALL
        }
    }

    fun isInfoDoc(): Boolean {
        return when (this) {
            TAX_NOTE, TAX_PAY_NOTE, TAX_NOTE_CANCEL, PAY_NOTE, DELIVERY_NOTES, ORDERS -> true
            else -> {
                false
            }
        }
    }

    fun DOC_NAME(): String {
        return DOC_NAME[this.state]

    }
    fun DOC_NAME(doc_id:String): String {
        if (doc_id == "-1") {
            return "מסמך"
        }
        return DOC_NAME[this.state]

    }
    fun isSupplierDoc(): Boolean {
        return when (this) {
            SUP_DELIVERY_NOTES,SUPPLIER_INVOICE, SUPPLIER_INVOICE_RECEIPT, SUPPLIER_INVOICE_CREDIT, SUPPLIER_PAYMENT, SUPPLIER_DEBT,SUP_CARTESET -> true
            else -> {
                false
            }
        }
    }

    fun DOC_NAME_SHORT(): String {
        return DOC_NAME_SHORT[this.state]

    }
}
